import React from "react";
import "./LandingBracketPanels.css";
import { navigateToView } from "utilities/js/NavigationHelper";
import getTimeSince from "utilities/js/TimeManager";
import { NavigatorWrapper } from "./NavigatorWrapper";
class ViewBracketOpener extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            viewId: '',
            bracketsToView: this.props.bracketsToView ? this.props.bracketsToView : [],
        };
        
        this.openViewLink = this.openViewLink.bind(this);
        this.setViewId = this.setViewId.bind(this);
        this.navigateToView = this.navigateToView.bind(this);
        
    }
    
    
    openViewLink(event){
        let bracketId = this.state.viewId;
        navigateToView({bracketId, routerNav: this.props.navigate});
    }
    
    setViewId(event){
        let viewId = event.currentTarget.value;
        this.setState({viewId: viewId});
    }
    
    navigateToView(event){
        let bracketId = event.currentTarget.dataset.name;
        navigateToView({bracketId, routerNav: this.props.navigate});
    }
    
    render(){
        let listOfBracketsToView = [];
        if(Object.keys(this.state.bracketsToView).length > 0){
            listOfBracketsToView = Object.keys(this.state.bracketsToView).map(id => {
                let bracket = this.state.bracketsToView[id];
                return (<>
                    <div key={id} className="clickable-list-item" >
                        <div className="clickable-list-item-main">
                            <div className="list-item-label" data-name={id} onClick={this.navigateToView}>{bracket.title}</div>
                            <div className="clickable-list-item-subtext">@{bracket.created_by?.username}</div>
                        </div>
                        <div className="clickable-list-item-additional-info">{getTimeSince(bracket.lastdate)}</div>
                        {/* <img className="open-new-tab-icon" alt="open-new-tab" src={openNewTabIcon}></img> */}
                    </div>
                </>)
            });
        }
        
        if(listOfBracketsToView.length > 0){
            listOfBracketsToView = [(<div key="container" className="bracket-id-list-container">{listOfBracketsToView}</div>)];
            listOfBracketsToView.unshift((<div key="label" className="section-header-text">Recent Brackets</div>))
        }else{
            listOfBracketsToView = [(
            <div key="container" className="bracket-id-list-container">
                <div className="empty-bracket-list">
                    You haven't viewed any brackets recently
                </div>
            </div>
            )]
        }
        
        
        return (
            <>
                <div className="landing-panel-container">
                
                {/* <div className="landing-nav-label-text">Input an id to view the related bracket</div>
                <div className="landing-nav-input-container">
                    <InputBox id="viewIdInput" class="tourney-name-input" placeholder="bracket-id..." value={this.state.viewId} valueChangedCallback={this.setViewId}></InputBox>
                    <button label='open-link' className='contact-us-button' onClick={this.openViewLink}><img className="open-new-tab-icon" alt="open-new-tab" src={RightArrowIcon}></img></button>
                </div>
                
                <hr className="landing-bracket-divider"/> */}
                
                <div className="bracket-id-list">
                {listOfBracketsToView}
                </div>
                
                </div>
            </>
        );
    }
}

export default NavigatorWrapper(ViewBracketOpener);
    